import React, { useState, useCallback } from 'react';
import { Row, Col, Radio } from 'antd';
import PropTypes from 'prop-types';

import CustomModal from '../common/modals/CustomModal';
import OnTraccrButton from '../common/buttons/OnTraccrButton';
import OnTraccrRadioGroup from '../common/inputs/OnTraccrRadioGroup';
import colors from '../constants/Colors';

export default function CheckAllYesNoModal({
  visible,
  onClose,
  onConfirm,
  showNA = true,
}) {
  const [selection, setSelection] = useState('yes');

  const handleConfirm = useCallback(() => {
    onConfirm(selection);
    onClose();
  }, [selection, onConfirm, onClose]);

  return (
    <CustomModal
      title="Check All Yes/No Fields"
      visible={visible}
      onCloseClicked={onClose}
      maskColor={colors.MODAL_MASK_DARK}
    >
      <div style={{ padding: 20 }}>
        <p style={{ marginBottom: 20, fontSize: 16, color: colors.REDESIGN_PRIMARY_TEXT }}>
          Select how you want to mark all Yes/No fields in this section:
        </p>
        <OnTraccrRadioGroup
          onChange={setSelection}
          value={selection}
        >
          <Radio value="yes">Yes</Radio>
          <Radio value="no">No</Radio>
          {showNA && <Radio value="n/a">N/A</Radio>}
        </OnTraccrRadioGroup>
      </div>
      <Row style={{ width: '100%' }} align="middle" justify="space-around">
        <Col>
          <OnTraccrButton
            title="Cancel"
            type="cancel"
            roundStyle
            onClick={onClose}
          />
        </Col>
        <Col>
          <OnTraccrButton
            title="Apply"
            roundStyle
            onClick={handleConfirm}
          />
        </Col>
      </Row>
    </CustomModal>
  );
}

CheckAllYesNoModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  showNA: PropTypes.bool,
};

CheckAllYesNoModal.defaultProps = {
  showNA: true,
};
